import { createContext, useContext, useEffect, useState } from 'react';
import api from '../api/client';
import { useAuth } from './AuthContext';
import { useFinca } from './FincaContext';

const PermisosContext = createContext(null);

export function PermisosProvider({ children }) {
  const { usuario } = useAuth();
  const { fincaActiva } = useFinca();
  const [permisos, setPermisos] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');

    // Si no hay usuario o no hay token → no llamamos
    if (!usuario || !token) {
      setPermisos([]);
      setCargando(false);
      return;
    }

    let cancelado = false;
    setCargando(true);

    api.get('/permisos/mios')
      .then(({ data }) => {
        if (!cancelado) setPermisos(data.permisos || []);
      })
      .catch((err) => {
        console.error('permisos/mios', err);
        if (!cancelado) setPermisos([]);
      })
      .finally(() => {
        if (!cancelado) setCargando(false);
      });

    return () => { cancelado = true; };
  }, [usuario, fincaActiva?.id]);

  const tienePermiso = (id) => {
    if (!usuario) return false;
    if (usuario.rol === 'super_admin') return true;
    return permisos.includes(id);
  };

  return (
    <PermisosContext.Provider value={{ permisos, tienePermiso, cargando }}>
      {children}
    </PermisosContext.Provider>
  );
}

export function usePermisos() {
  const ctx = useContext(PermisosContext);
  if (!ctx) throw new Error('usePermisos debe usarse dentro de PermisosProvider');
  return ctx;
}

export function usePermiso(id) {
  return usePermisos().tienePermiso(id);
}